import { createSlice } from "@reduxjs/toolkit";
import { useCallback } from "react";
import { useDispatch, useSelector } from "../store";

const initialState = {
  action: null,
  entity: {},
};

const slice = createSlice({
  name: "newReduxTest",
  initialState,
  reducers: {
    getEntity(state, action) {
      state.entity = action.payload;
    },
    setEntity(state, action) {
      state.entity = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

export const { actions } = slice;

export function useEntity() {
  const dispatch = useDispatch();
  const newReduxTest = useSelector(state => state.newReduxTest);

  const onSetEntity = useCallback(
    entity => {
      dispatch(slice.actions.setEntity(entity));
    },
    [dispatch]
  );

  return { entity: newReduxTest.entity, setEntity: onSetEntity };
}

// Actions
export const { getEntity } = slice.actions;
